import { makeStyles } from '@material-ui/core';

export default makeStyles({
  menuPage: {
    height: '100%',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    fontFamily: 'PP Object Sans',
    overflowY: 'hidden',
    '& *': {
      fontFamily: 'PP Object Sans',
    },
  },
});
